<mat-form-field class="field-filter" subscriptSizing="dynamic" *ngIf="categories.length">
  <mat-label>Filtre</mat-label>
  <mat-select [(ngModel)]="filterNews" (ngModelChange)="filterNews$.next($event)" multiple>
    <mat-option *ngFor="let cat of categories" [value]="cat.idCategorie">{{cat.titre}}</mat-option>
  </mat-select>
</mat-form-field>